import { INSURANCE_SUB_PRODUCT_TYPES } from '@nerdwallet/marketplace/constants';
import { getSubProductType } from '@nerdwallet/marketplace/selectors/common';
export var TOOLTIP_TEXT = {
  auto_loans: "NerdWallet's ratings are determined by our editorial team. The scoring formula takes into account factors like maximum rates, variety of loan options, visibility of borrower requirements, accessibility, speed of funding, fees and more.",
  banking: "NerdWallet's ratings are determined by our editorial team. The scoring formulas take into account multiple data points for each financial product and service.",
  credit_cards: "NerdWallet's ratings are determined by our editorial team. The scoring formula takes into account the type of card being reviewed (such as cash back, travel or balance transfer) and the card's rates, fees, rewards and other features.",
  default: "NerdWallet's ratings are determined by our editorial team. The scoring formulas take into account multiple data points for each financial product and service.",
  education_loans: "NerdWallet's ratings are determined by our editorial team. The scoring formula for student loan products takes into account more than 50 data points across multiple categories, including repayment options, customer service, lender transparency, loan eligibility and underwriting criteria.",
  insurance: "NerdWallet's ratings are determined by our editorial team. The scoring formula takes into account consumer complaint and customer satisfaction data.",
  investing: "NerdWallet's ratings are determined by our editorial team. The scoring formula for online brokers and robo-advisors takes into account over 15 factors, including account fees and minimums, investment choices, customer support and mobile app capabilities.",
  mortgages: "NerdWallet's ratings are determined by our editorial team. The scoring formula takes into account loan types and loan products offered, online conveniences, online mortgage rate information, and the rate spread and origination fee lenders reported in the latest available HMDA data.",
  personal_loans: "NerdWallet's ratings are determined by our editorial team. The scoring formula takes into account factors we consider to be consumer-friendly, including impact to credit score, rates and fees, customer experience and responsible lending practices.",
  auto_insurance: "NerdWallet's ratings are determined by our editorial team. The scoring formula incorporates discounts, website transparency, financial strength, complaint data and more.",
  home_renters_insurance: "NerdWallet's ratings are determined by our editorial team. The scoring formula incorporates discounts, coverage options, website transparency, financial strength, complaint data and more.",
  life_insurance: "NerdWallet's ratings are determined by our editorial team. The scoring formula incorporates consumer experience, financial strength ratings and complaint data.",
  pet_insurance: "NerdWallet's ratings are determined by our editorial team. The scoring formula incorporates financial strength, coverage options, customer experience, discounts and more.",
  travel_insurance: "NerdWallet's ratings are determined by our editorial team. The scoring formula incorporates coverage options, customer experience, customizability, cost and more."
};
export var getTooltipText = function getTooltipText(productType, ratingTextTooltip, entity) {
  var tooltipText = TOOLTIP_TEXT.default;
  var titleOverride;

  if (ratingTextTooltip) {
    tooltipText = ratingTextTooltip;
  } else if (productType) {
    switch (getSubProductType(entity)) {
      case INSURANCE_SUB_PRODUCT_TYPES.AUTO:
      case INSURANCE_SUB_PRODUCT_TYPES.CAR:
        tooltipText = TOOLTIP_TEXT.auto_insurance;
        titleOverride = "How are NerdWallet's ratings determined?";
        break;

      case INSURANCE_SUB_PRODUCT_TYPES.HOME:
      case INSURANCE_SUB_PRODUCT_TYPES.HOMEOWNERS_PROPERTY:
      case INSURANCE_SUB_PRODUCT_TYPES.RENTERS_SUB:
        tooltipText = TOOLTIP_TEXT.home_renters_insurance;
        titleOverride = "How are NerdWallet's ratings determined?";
        break;

      case INSURANCE_SUB_PRODUCT_TYPES.LIFE_SUB:
      case INSURANCE_SUB_PRODUCT_TYPES.LIFE:
        tooltipText = TOOLTIP_TEXT.life_insurance;
        titleOverride = "How are NerdWallet's ratings determined?";
        break;

      case INSURANCE_SUB_PRODUCT_TYPES.PET_SUB:
      case INSURANCE_SUB_PRODUCT_TYPES.PET:
        tooltipText = TOOLTIP_TEXT.pet_insurance;
        titleOverride = "How are NerdWallet's ratings determined?";
        break;

      case INSURANCE_SUB_PRODUCT_TYPES.TRAVEL_SUB:
      case INSURANCE_SUB_PRODUCT_TYPES.TRAVEL:
        tooltipText = TOOLTIP_TEXT.travel_insurance;
        break;

      default:
        tooltipText = TOOLTIP_TEXT[productType] || TOOLTIP_TEXT.default;
        break;
    }
  }

  return {
    tooltipText: tooltipText,
    titleOverride: titleOverride
  };
};